export const reserveList = [

  {
    reserveListId: "rl1",
    id: 1,
    name: "Luke",
    lastname: "Skywalker",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456001",
    assignment: {
      calendar: "r1",
    },
    timestamps: {
      show_on_rl_until: "2025-12-30T00:00:00.000+01:00",
      created: "2025-01-02T00:00:00.000+01:00",
    },
    service: {
      id: 1,
      serviceName: "Haircut",
      price: 50,
      time: 30,
    },
  },
  {
    reserveListId: "rl2",
    id: 2,
    name: "Darth",
    lastname: "Vader",
    note: "Sith Lord",
    blacklist: true,
    marketingAgreement: false,
    tel: "+123456002",
    assignment: {
      calendar: "r6",
    },
    timestamps: {
      show_on_rl_until: "2025-11-30T00:00:00.000Z",
      created: "2025-02-10T09:00:00.000Z",
    },
    service: {
      id: 3,
      serviceName: "Beard Trim",
      price: 25,
      time: 15,
    },
  },
  {
    reserveListId: "rl3",
    id: 3,
    name: "Princess",
    lastname: "Leia",
    note: "General of the Resistance",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456003",
    assignment: {
      calendar: "r2",
    },
    timestamps: {
      show_on_rl_until: "2025-12-25T00:00:00.000Z",
      created: "2025-03-05T09:00:00.000Z",
    },
    service: {
      id: 8,
      serviceName: "Hair Coloring",
      price: 150,
      time: 120,
    },
  },
  {
    reserveListId: "rl4",
    id: 4,
    name: "Han",
    lastname: "Solo",
    note: "Smuggler and Captain of the Millennium Falcon",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456004",
    assignment: {
      calendar: "r5",
    },
    timestamps: {
      show_on_rl_until: "2025-10-01T00:00:00.000Z",
      created: "2025-04-01T09:00:00.000Z",
    },
    service: {
      id: 20,
      serviceName: "Makeup Application",
      price: 80,
      time: 45,
    },
  },
  {
    reserveListId: "rl5",
    id: 5,
    name: "Chewbacca",
    lastname: "",
    note: "Wookiee and Co-Pilot of the Millennium Falcon",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456005",
    assignment: {
      calendar: "r1",
    },
    timestamps: {
      show_on_rl_until: "2025-12-01T00:00:00.000Z",
      created: "2025-05-10T09:00:00.000Z",
    },
    service: {
      id: 14,
      serviceName: "Manicure",
      price: 70,
      time: 40,
    },
  },
  {
    reserveListId: "rl6",
    id: 6,
    name: "Yoda",
    lastname: "",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456006",
    assignment: {
      "calendar": "r4",
    },
    timestamps: {
      show_on_rl_until: "2025-12-28T00:00:00.000Z",
      created: "2025-06-15T09:00:00.000Z",
    },
    service: {
      id: 15,
      serviceName: "Pedicure",
      price: 80,
      time: 50,
    },
  },
  {
    reserveListId: "rl7",
    id: 7,
    name: "Obi-Wan",
    lastname: "Kenobi",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456007",
    assignment: {
      calendar: "r1",
    },
    timestamps: {
      show_on_rl_until: "2025-12-15T00:00:00.000Z",
      created: "2025-07-20T09:00:00.000Z",
    },
    service: {
      id: 21,
      serviceName: "Eyelash Extensions",
      price: 150,
      time: 90,
    },
  },
  {
    reserveListId: "rl8",
    id: 8,
    name: "R2-D2",
    lastname: "",
    note: "Droid",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456008",
    assignment: {
      calendar: "r6",
    },
    timestamps: {
      show_on_rl_until: "2025-12-10T00:00:00.000Z",
      created: "2025-08-25T09:00:00.000Z",
    },
    service: {
      id: 1,
      serviceName: "Haircut",
      price: 50,
      time: 30,
    },
  },
  {
    reserveListId: "rl9",
    id: 9,
    name: "C-3PO",
    lastname: "",
    note: "Protocol Droid",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456009",
    assignment: {
      calendar: "r2",
    },
    timestamps: {
      show_on_rl_until: "2025-11-25T00:00:00.000Z",
      created: "2025-09-30T09:00:00.000Z",
    },
    service: {
      id: 11,
      serviceName: "Keratin Treatment",
      price: 300,
      time: 120,
    },
  },
  {
    reserveListId: "rl10",
    id: 10,
    name: "Padmé",
    lastname: "Amidala",
    note: "Queen of Naboo",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456010",
    assignment: {
      calendar: "r5",
    },
    timestamps: {
      show_on_rl_until: "2025-12-31T00:00:00.000Z",
      created: "2025-10-05T09:00:00.000Z",
    },
    service: {
      id: 11,
      serviceName: "Keratin Treatment",
      price: 300,
      time: 120,
    },
  },
  {
    reserveListId: "rl11",
    id: 11,
    name: "Qui-Gon",
    lastname: "Jinn",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456011",
    assignment: {
      calendar: "r1",
    },
    timestamps: {
      show_on_rl_until: "2025-12-29T00:00:00.000Z",
      created: "2025-11-10T09:00:00.000Z",
    },
    service: {
      id: 1,
      serviceName: "Haircut",
      price: 50,
      time: 30,
    },
  },
  {
    reserveListId: "rl12",
    id: 1,
    name: "Luke",
    lastname: "Skywalker",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456001",
    assignment: {
      calendar: "r6",
    },
    timestamps: {
      show_on_rl_until: "2025-12-30T00:00:00.000+01:00",
      created: "2025-01-02T00:00:00.000+01:00",
    },
    service: {
      id: 1,
      serviceName: "Shave",
      price: 150,
      time: 130,
    },
  },
  {
    reserveListId: "rl13",
    id: 1,
    name: "Luke",
    lastname: "Skywalker",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456001",
    assignment: {
      calendar: null,
    },
    timestamps: {
      show_on_rl_until: "2025-12-30T00:00:00.000+01:00",
      created: "2025-01-02T00:00:00.000+01:00",
    },
    service: {
      id: null,
      serviceName: '',
      price: '',
      time: '',
    },
  },

]
